// Actions de la matrice de droits (L02) — UNE seule définition pour le serveur et l'écran.
export const ACTIONS = ['voir', 'creer', 'modifier', 'valider', 'exporter', 'sensibles'];

/** Actions réellement appliquées côté serveur. Les autres sont « non appliqué pour l'instant » : l'écran n'offre pas de case. */
export const ACTIONS_APPLIQUEES = ['voir', 'creer', 'modifier'];
